import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import useApiStable from '../utils/useApiStable';

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [personId, setPersonId] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const api = useApiStable();

  useEffect(() => {
    // Finde Person anhand der Email des eingeloggten Users
    if (user?.username) {
      api.get('/persons')
        .then(persons => {
          const person = persons.find(p => p.email === user.username);
          if (person) {
            setPersonId(person.id);
          } else {
            setError('Person nicht gefunden');
          }
          setLoading(false);
        })
        .catch(err => {
          setError('Fehler beim Laden der Daten: ' + err.message);
          setLoading(false);
        });
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!personId) {
      setError('Person-ID nicht gefunden');
      return;
    }

    if (newPassword.length < 6) {
      setError('Das neue Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }

    try {
      const response = await api.fetchRaw(`/persons/${personId}/change-password`, {
        method: 'POST',
        body: JSON.stringify({
          oldPassword: oldPassword,
          newPassword: newPassword
        })
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess('Passwort erfolgreich geändert!');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        setError(result.error || 'Passwortänderung fehlgeschlagen');
      }
    } catch (err) {
      setError(err.message || 'Passwortänderung fehlgeschlagen');
    }
  };

  if (loading) {
    return (
      <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
        <p>Lädt...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
        <p>Bitte melden Sie sich an, um Ihr Passwort zu ändern.</p>
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
      <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Passwort ändern</h2>

        {error && (
          <div style={{
            background: '#ffebee',
            color: '#c62828',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '20px',
            fontSize: '0.9em'
          }}>
            {error}
          </div>
        )}

        {success && (
          <div style={{
            background: '#e8f5e9',
            color: '#2e7d32',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '20px',
            fontSize: '0.9em'
          }}>
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Altes Passwort*
            </label>
            <input
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Neues Passwort* (mind. 6 Zeichen)
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Neues Passwort bestätigen*
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            type="submit"
            style={{
              width: '100%',
              padding: '12px',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1em',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Passwort ändern
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;

